import isEmailValid from "@validationSvc/functions/isEmailValid";
import isPasswordValid from "@validationSvc/functions/isPasswordValid";

const validationSvc = {
  isEmailValid,
  isPasswordValid,
};

export default validationSvc;
